import { type PopoverContentProps } from '@radix-ui/react-popover';

import { PopoverContent } from '../../Popover';
import { cn } from '../../utils';

export const MultiselectPopoverContent = ({
  className,
  children,
  ...props
}: PopoverContentProps & {
  container?: HTMLDivElement | null;
  dialog?: boolean;
}) => {
  return (
    <PopoverContent
      side="bottom"
      align="center"
      onOpenAutoFocus={(e) => e.preventDefault()}
      collisionPadding={12}
      className={cn(
        'w-[var(--radix-popover-trigger-width)] max-h-[var(--radix-popover-content-available-height)] min-h-0 p-0 shadow-xl overflow-y-auto',
        className,
      )}
      {...props}
    >
      {children}
    </PopoverContent>
  );
};
